module.exports = __webpack_public_path__ + "img/open.3a252c69.png";